<script setup>
import { store } from '@/store/appStore.js'
import RoleSelect from '@/components/shell/RoleSelect.vue'
import AppShell from '@/components/shell/AppShell.vue'
</script>

<template>
  <RoleSelect v-if="!store.state.role" />
  <AppShell v-else />
</template>
